// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriverUI_containerLabelSwitches__U0ng8{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 0.0625rem solid #f0f0f0;
  padding-bottom: 0.9375rem;
}

.DriverUI_twoCardsLayout__zZxJ9 {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 1.5rem;
  align-items: flex-start;
  margin-top: 1.875rem;
}

.DriverUI_leftCard__OGjkM {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.DriverUI_rightCard__l\\+Rs6 {
  flex-grow: 1;
}

.DriverUI_switches__\\+ULWN{
  display: flex;
  gap: 0.625rem;
}

.DriverUI_card__A511y {
  background-color: #ffffff;
  border-radius: 0.5rem;
  padding: 1.5rem;
  border: 0.0625rem solid #f0f0f0;
}

.DriverUI_permissions__RKJu4{
  display: flex;
  gap: 1.25rem;
  margin: 0;
}

.DriverUI_permissions__RKJu4 > div {
  text-align: center;
}

.DriverUI_permissions__RKJu4 span {
  display: block;
}

.DriverUI_avatarUploader__Jsh-0 .ant-upload-select-picture-card {
  width: 100%;
  height: auto;
  aspect-ratio: 1 / 1;
  border-radius: 0.5rem;
  background-color: #fbfbfb;
  border: 0.0625rem solid #d2d2d2;
  overflow: hidden;
}

.DriverUI_placeholderImg__ioF1a svg {
  width: 3.125rem;
  height: 3.125rem;
  color: var(--gray);
}

.DriverUI_photo__rDAil{
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  object-fit: cover;
}

.DriverUI_disclaimer__0N4rI {
  text-align: center;
  display: block;
  margin-top: 0.625rem;
  color: #999;
  font-size: 0.75rem;
}

.DriverUI_availabilityLabel__vHENo {
  text-align: center;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #555;
  margin-top: 1.5rem;
  margin-bottom: 0.25rem;
}

.DriverUI_subActions__sVlzu{
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: auto;
}

.DriverUI_btn__8jjIp {
  border: 0.0625rem solid #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.75rem;
  width: 100%;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.875rem;
}

.DriverUI_btn__8jjIp:hover {
  border-color: #F9A41A;
  color: #F9A41A;
}

.DriverUI_btnMap__65QZ2{
  background-color: #FDF8E5;
  color: #F9A41A;
  border-color: transparent;
}

.DriverUI_btnMap__65QZ2:hover {
  background-color: #fbeaba;
  color: #F9A41A;
  border-color: transparent;
}

.DriverUI_btnAvailable__4gy68{
  background-color: #F1F5FE;
  color:#3357E3;
  border-color: transparent;
}

.DriverUI_btnAvailable__4gy68:hover{
  background-color: #e0e8fd;
  color: #3357E3;
  border-color: transparent;
}

.DriverUI_btnLock__mpeWV{
  background-color: #FEF2F4;
  color:#ED243D;
  border-color: transparent;
}

.DriverUI_btnLock__mpeWV:hover {
  background-color: #fcd5db;
  color:#ED243D;
  border-color: transparent;
}

.DriverUI_actions__tnjBD{
  display: flex;
  gap: 1.875rem;
  justify-content: flex-end;
}

.DriverUI_title__IPssa {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 1.25rem;
}

.DriverUI_label__AWZvl {
  font-weight: 600;
  color: #666;
  font-size: 0.75rem;
  letter-spacing: 0.03125rem;
  text-transform: uppercase;
}

.DriverUI_input__4wVZg,
.DriverUI_input__4wVZg .ant-select-selector {
  background-color: #ffffff !important;
  border-color: #d9d9d9 !important;
  border-radius: 0.25rem !important;
  box-shadow: none !important;
  height: 2.75rem !important;
}

.DriverUI_input__4wVZg:focus,
.DriverUI_input__4wVZg:hover,
.DriverUI_input__4wVZg .ant-select-selector:focus,
.DriverUI_input__4wVZg .ant-select-selector:hover {
  border-color: #F9A41A !important;
  box-shadow: none !important;
}

.DriverUI_submit__jpMI3 {
  width: 12.5rem;
  font-weight: 700;
  font-size: 0.875rem;
  border-radius: 0.5rem;
  justify-content: center;
  height: 2.75rem;
  display: flex;
  align-items: center;
}

.DriverUI_submit__jpMI3:hover {
  background: #e69614 !important;
  color: white !important;
}

.DriverUI_header__nEjsv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.9375rem;
  border-bottom: 0.0625rem solid #cfcfcf;
  padding-bottom: 0.9375rem;
}

.DriverUI_loaderWrap__O0kY4{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.DriverUI_tagAvailable__EKyHf{
  width: 100%;
  margin-top: 0.5rem;
  text-align: center;
  padding: 0.375rem 0;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.8125rem;
}

@media (max-width: 992px) {
  .DriverUI_twoCardsLayout__zZxJ9 {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .DriverUI_containerLabelSwitches__U0ng8 {
    flex-wrap: wrap;
    gap: 1rem;
  }

  .DriverUI_actions__tnjBD {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/driver-detail/styles/DriverUI.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;;;EAIE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EACA;IACE,eAAe;IACf,SAAS;EACX;;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".containerLabelSwitches{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  border-bottom: 0.0625rem solid #f0f0f0;\n  padding-bottom: 0.9375rem;\n}\n\n.twoCardsLayout {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  gap: 1.5rem;\n  align-items: flex-start;\n  margin-top: 1.875rem;\n}\n\n.leftCard {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.rightCard {\n  flex-grow: 1;\n}\n\n.switches{\n  display: flex;\n  gap: 0.625rem;\n}\n\n.card {\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  border: 0.0625rem solid #f0f0f0;\n}\n\n.permissions{\n  display: flex;\n  gap: 1.25rem;    \n  margin: 0;\n}\n\n.permissions > div {\n  text-align: center;\n}\n\n.permissions span {\n  display: block;\n}\n\n\n.avatarUploader :global(.ant-upload-select-picture-card) {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 1 / 1;\n  border-radius: 0.5rem;\n  background-color: #fbfbfb;\n  border: 0.0625rem solid #d2d2d2;\n  overflow: hidden;\n}\n\n.placeholderImg svg {\n  width: 3.125rem;\n  height: 3.125rem;\n  color: var(--gray);\n}\n.photo{\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center center;\n  object-fit: cover;\n}\n\n.disclaimer {\n  text-align: center;\n  display: block;\n  margin-top: 0.625rem;\n  color: #999;\n  font-size: 0.75rem;\n}\n\n.availabilityLabel {\n  text-align: center;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #555;\n  margin-top: 1.5rem;\n  margin-bottom: 0.25rem;\n}\n\n.subActions{\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: auto;\n}\n\n.btn {\n  border: 0.0625rem solid #d9d9d9;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.75rem;\n  width: 100%;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.btn:hover {\n  border-color: #F9A41A;\n  color: #F9A41A;\n}\n\n.btnMap{\n  background-color: #FDF8E5;\n  color: #F9A41A;\n  border-color: transparent;\n}\n\n.btnMap:hover {\n  background-color: #fbeaba;\n  color: #F9A41A;\n  border-color: transparent;\n}\n\n.btnAvailable{\n  background-color: #F1F5FE;\n  color:#3357E3;\n  border-color: transparent;\n}\n\n.btnAvailable:hover{\n  background-color: #e0e8fd;\n  color: #3357E3;\n  border-color: transparent;\n}\n\n.btnLock{\n  background-color: #FEF2F4;\n  color:#ED243D;\n  border-color: transparent;\n}\n\n.btnLock:hover {\n  background-color: #fcd5db;\n  color:#ED243D;\n  border-color: transparent;\n}\n\n.actions{\n  display: flex;\n  gap: 1.875rem;\n  justify-content: flex-end;\n}\n\n.title {\n  color: var(--darkGray);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 1.25rem;\n}\n  \n.label {\n  font-weight: 600;\n  color: #666;\n  font-size: 0.75rem;\n  letter-spacing: 0.03125rem;\n  text-transform: uppercase;\n}\n\n.input,\n.input :global(.ant-select-selector) {\n  background-color: #ffffff !important;\n  border-color: #d9d9d9 !important;\n  border-radius: 0.25rem !important;\n  box-shadow: none !important;\n  height: 2.75rem !important;\n}\n\n.input:focus,\n.input:hover,\n.input :global(.ant-select-selector):focus,\n.input :global(.ant-select-selector):hover {\n  border-color: #F9A41A !important;\n  box-shadow: none !important;\n}\n\n.submit {\n  width: 12.5rem;\n  font-weight: 700;\n  font-size: 0.875rem;\n  border-radius: 0.5rem;\n  justify-content: center;\n  height: 2.75rem;\n  display: flex;\n  align-items: center;\n}\n\n.submit:hover {\n  background: #e69614 !important;\n  color: white !important;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.9375rem;\n  border-bottom: 0.0625rem solid #cfcfcf;\n  padding-bottom: 0.9375rem;\n}\n\n.loaderWrap{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.tagAvailable{\n  width: 100%;\n  margin-top: 0.5rem;\n  text-align: center;\n  padding: 0.375rem 0;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  font-size: 0.8125rem;\n}\n\n@media (max-width: 992px) {\n  .twoCardsLayout {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  .containerLabelSwitches {\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  .actions {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerLabelSwitches": `DriverUI_containerLabelSwitches__U0ng8`,
	"twoCardsLayout": `DriverUI_twoCardsLayout__zZxJ9`,
	"leftCard": `DriverUI_leftCard__OGjkM`,
	"rightCard": `DriverUI_rightCard__l+Rs6`,
	"switches": `DriverUI_switches__+ULWN`,
	"card": `DriverUI_card__A511y`,
	"permissions": `DriverUI_permissions__RKJu4`,
	"avatarUploader": `DriverUI_avatarUploader__Jsh-0`,
	"placeholderImg": `DriverUI_placeholderImg__ioF1a`,
	"photo": `DriverUI_photo__rDAil`,
	"disclaimer": `DriverUI_disclaimer__0N4rI`,
	"availabilityLabel": `DriverUI_availabilityLabel__vHENo`,
	"subActions": `DriverUI_subActions__sVlzu`,
	"btn": `DriverUI_btn__8jjIp`,
	"btnMap": `DriverUI_btnMap__65QZ2`,
	"btnAvailable": `DriverUI_btnAvailable__4gy68`,
	"btnLock": `DriverUI_btnLock__mpeWV`,
	"actions": `DriverUI_actions__tnjBD`,
	"title": `DriverUI_title__IPssa`,
	"label": `DriverUI_label__AWZvl`,
	"input": `DriverUI_input__4wVZg`,
	"submit": `DriverUI_submit__jpMI3`,
	"header": `DriverUI_header__nEjsv`,
	"loaderWrap": `DriverUI_loaderWrap__O0kY4`,
	"tagAvailable": `DriverUI_tagAvailable__EKyHf`
};
export default ___CSS_LOADER_EXPORT___;
